import { Injectable, Injector } from '@angular/core';
import { ApiRestaurantsService, RestaurantAnimationDto } from '@timechef/core/api';
import { GetAnimationsResult } from '@timechef/core/api/models/get-animations-result';
import { AuthRepository } from '@timechef/core/auth';
import { CouldBeCached, IN_CACHE, IN_CACHE_SOURCE } from '@timechef/core/utils/elf-utils';
import { RestaurantsRepository } from '@timechef/features/restaurants/state';
import { tap } from 'rxjs';
import { AnimationsRepository } from '.';

const ANIMATIONS_PAGE_SIZE = 10;

@Injectable({
  providedIn: 'root',
})
export class AnimationsService {
  authRepo: AuthRepository;
  constructor(
    private animationsRepository: AnimationsRepository,
    private api: ApiRestaurantsService,
    private restaurantsRepo: RestaurantsRepository,
    injector: Injector,
  ) {
    this.authRepo = injector.get(AuthRepository);
  }

  getAnimations(pageIndex: number) {
    const animationInRestaurantIds = this.restaurantsRepo.getRestaurantsAnimationsIds();
    return this.api.getAnimations({ SiteName: this.authRepo.getCurrentSiteName(), PageIndex: pageIndex, PageSize: ANIMATIONS_PAGE_SIZE }).pipe(
      this.animationsRepository.animationsByPeriodDS.trackRequestStatus(),
      this.animationsRepository.skipWhileAnimationsCached(`animations-${pageIndex}`, IN_CACHE_SOURCE),
      tap((data: CouldBeCached<GetAnimationsResult>) => {
        if (data === IN_CACHE) {
          return;
        }

        this.animationsRepository.addAnimations(data.animations, data.hasMore, pageIndex, animationInRestaurantIds);
      }),
    );
  }

  addAnimationsFromRestaurants(animations: RestaurantAnimationDto[]) {
    return this.animationsRepository.addAnimationsFromRestaurants(animations);
  }

  getAnimationById(id: number) {
    return this.animationsRepository.getAnimationById(id);
  }
}
